module.exports = __webpack_public_path__ + "static/img/OPELogo.b721f9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OPELogo.jpg
// module id = BTff
// module chunks = 1